








import vue from "vue";
import { VUEX_EXERCISE_GETTER_NAMES, VUEX_EXERCISE_NAMESPACE } from "@tt-app/constants";

const { CURRENT_PAGE } = VUEX_EXERCISE_GETTER_NAMES;

interface Computed {
  hasHints: boolean;
  hints: string[];
  visible: boolean;
}

export default vue.extend<any, any, Computed, any>({
  name: "ExerciseHints",

  computed: {
    hasHints() {
      return this.hints.length > 0;
    },

    hints() {
      const currentPage = this.$store.getters[`${VUEX_EXERCISE_NAMESPACE}/${CURRENT_PAGE}`];

      return currentPage?.hints || [];
    },

    visible() {
      return this.hasHints && this.$store.state.exercise.settings.hints;
    }
  }
});
